'use client';

import { getCommentsScopeKey } from '@/features/comments/utils/get-comments-scope-key.util';
import type { PublicationKind } from '@/features/comments/types/publication-kind';
import type { Comment } from '@/types/comment';
import { CreateComment } from './create-comment';
import { useCommentsStore } from '../store/comments.store';

interface CreateCommentWrapperProps {
  articleId?: number;
  postId?: number;
  chapterId?: string;
  placeholder?: string;
  className?: string;
  publicationKind?: PublicationKind;
  focusOnMount?: boolean;
}

export function CreateCommentWrapper({
  articleId,
  postId,
  chapterId,
  placeholder = 'Комментарий...',
  className = '',
  publicationKind = 'comment',
  focusOnMount = false,
}: CreateCommentWrapperProps) {
  const addComment = useCommentsStore((state) => state.addComment);
  const scopeKey = getCommentsScopeKey({ articleId, postId, chapterId });

  const handleSubmit = (newComment: Comment) => {
    console.log('CreateCommentWrapper: Comment submitted:', newComment);
    addComment(scopeKey, newComment);
    console.log('CreateCommentWrapper: Comment added to store');
  };

  return (
    <CreateComment
      articleId={articleId}
      postId={postId}
      chapterId={chapterId}
      placeholder={placeholder}
      className={className}
      publicationKind={publicationKind}
      focusOnMount={focusOnMount}
      onSubmit={handleSubmit}
    />
  );
}
